import React from 'react';
import { useTranslation } from 'react-i18next';
import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import SyncMyCardImage from '../../../../assets/png/sync-my-card-promo.png';
import { UserMessage } from '../../../../DesignSystem/LiliUserMessage/UserMessage';
import { CloseButton, CloseButtonColor, CloseButtonSize } from '../../../../DesignSystem/LiliCloseButton/CloseButton';

export interface SyncYourCardPromotionalModalProps {
  onClose: () => void;
  onUpgrade: () => void;
}

const SyncYourCardPromotionalModalFooter = (props: SyncYourCardPromotionalModalProps) => {
  const { onClose, onUpgrade } = props;
  const { t } = useTranslation();

  return (
    <div className='flex flex-col justify-between'>
      <div className='text-bw07 text-[14px] font-metricR leading-[19px] mb-[25px]'>
        {t('TRANSACTIONS_FACELIFT.SYNC_CARD.SYNC_CARD_PROMOTION.UPGRADE_TO_USE')}
      </div>
      <div className='flex justify-center gap-[14px] mb-[40px]'>
        <LiliButton
          title={t('TRANSACTIONS_FACELIFT.SYNC_CARD.SYNC_CARD_PROMOTION.CANCEL')}
          id='cancel'
          onClick={onClose}
          className='h-[44px]'
          type={LiliButtonType.SECONDARY}
        />
        <LiliButton
          title={t('TRANSACTIONS_FACELIFT.SYNC_CARD.SYNC_CARD_PROMOTION.UPGRADE_NOW')}
          id='upgrade-now'
          onClick={() => {
            onUpgrade();
            onClose();
          }}
          className='h-[44px]'
          isLoading={false}
        />
      </div>
    </div>
  );
};

const SyncYourCardPromotionalModalContent = (props: SyncYourCardPromotionalModalProps) => {
  const { onClose, onUpgrade } = props;
  const { t } = useTranslation();

  return (
    <div className='flex flex-col basis-6/10 mr-[32px] max-w-[434px] justify-between'>
      <div className='mt-[42px]'>
        <div className='font-metricRMedium text-gray-700 leading-[38px] text-[28px] mb-[14px]'>
          {t('TRANSACTIONS_FACELIFT.SYNC_CARD.SYNC_CARD_PROMOTION.TITLE')}
        </div>
        <div className='text-bw07 text-[14px] font-metricR leading-[19px]'>
          {t('TRANSACTIONS_FACELIFT.SYNC_CARD.SYNC_CARD_PROMOTION.BEMEFITS')}
        </div>
        <ul className='text-bw08 text-[14px] font-metricR leading-[20px] list-disc pl-[20px] w-[345px]'>
          <li className='mb-[8px] mt-[4px]'>{t('TRANSACTIONS_FACELIFT.SYNC_CARD.SYNC_CARD_PROMOTION.SYNC_BENEFIT')}</li>
          <li>{t('TRANSACTIONS_FACELIFT.SYNC_CARD.SYNC_CARD_PROMOTION.CATEGORIZATION_BENEFIT')}</li>
        </ul>
      </div>
      <SyncYourCardPromotionalModalFooter onClose={onClose} onUpgrade={onUpgrade} />
    </div>
  );
};

export const SyncYourCardPromotionalModal = (props: SyncYourCardPromotionalModalProps) => {
  const { onClose, onUpgrade } = props;
  const { t } = useTranslation();

  return (
    <UserMessage onClick={onClose} id='sync-your-card-promotional-modal'>
      <div className='absolute top-[10px] left-[10px] bg-action02 px-[9px] rounded-[4px]'>
        <div className='text-bw00 text-[16px] font-metricR leading-[23px]'>
          {t('TRANSACTIONS_FACELIFT.SYNC_CARD.SYNC_CARD_PROMOTION.NEW')}
        </div>
      </div>
      <div className='flex flex-row rounded-[12px] bg-bw00 w-[836px] h-[443px] font-metricR text-bw08 pl-[32px]'>
        <SyncYourCardPromotionalModalContent onClose={onClose} onUpgrade={onUpgrade} />
        <div className='flex basis-4/10'>
          <img src={SyncMyCardImage} className='flex items-center rounded-[12px]' alt='Sync Your Card' />
          <div className='absolute top-[16px] right-[16px]'>
            <CloseButton
              size={CloseButtonSize.Large}
              id='close-modal'
              color={CloseButtonColor.Gray}
              onClick={onClose}
              circle
            />
          </div>
        </div>
      </div>
    </UserMessage>
  );
};
